import React from "react";

const Projects = () => {
  return (
   <section id="projects" className="py-20 bg-background">
  <div className="container mx-auto px-6">
    <h2 className="text-4xl font-bold text-foreground text-center mb-16">
      Featured Projects
    </h2>
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {/* Project 1 */}
      <div className="overflow-hidden rounded-lg shadow-sm border border-border">
        <img
          src="assets/Modern_Hillside.png"
          alt="Modern two-story residential house with large windows and contemporary architecture"
          className="w-full h-64 object-cover"
        />
        <div className="p-6">
          <h3 className="text-xl font-semibold text-foreground mb-2">
            Hillside Residence
          </h3>
          <p className="text-muted-foreground">
            Modern family home with panoramic views
          </p>
        </div>
      </div>

      {/* Project 2 */}
      <div className="overflow-hidden rounded-lg shadow-sm border border-border">
        <img
          src="assets/Urban_Loft_Design.png"
          alt="Elegant living room interior with modern furniture and large windows"
          className="w-full h-64 object-cover"
        />
        <div className="p-6">
          <h3 className="text-xl font-semibold text-foreground mb-2">
            Urban Loft Interior
          </h3>
          <p className="text-muted-foreground">
            Contemporary interior design in downtown apartment
          </p>
        </div>
      </div>

      {/* Project 3 */}
      <div className="overflow-hidden rounded-lg shadow-sm border border-border">
        <img
          src="assets/Heritage_Home.png"
          alt="Traditional home exterior renovation with new siding and landscaping"
          className="w-full h-64 object-cover"
        />
        <div className="p-6">
          <h3 className="text-xl font-semibold text-foreground mb-2">
            Heritage Home Renovation
          </h3>
          <p className="text-muted-foreground">
            Preserving character with modern updates
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

  );
};

export default Projects;
